import { MathComponent } from "mathjax-react";

export default function DesignPage() {
  return (
    <div style={{ backgroundImage: 'url(https://static.igem.wiki/teams/4260/wiki/imagen/project/biosensor/fondos-de-biosensor/project-biosensor.png)', minHeight: '100vh' }}>
      <div className="p-10 max-w-2xl m-auto pt-20 text-white">
        <h1 className="text-6xl text-center text-white font-bold">
          Design
        </h1>
        <h2 className="h2">
          Overview
        </h2>
        <p className="p">
          First approach.
          It is important to mention that the implementation plan form TecCEM 2021 [1] inspired us to continue with the biosensor. It was decided to  keep on going with the fundamental purpose; detect and quantify EDCs. But this year Hydro-Defense decided to renovate each component and add things that were missing. Drawbacks from TecCEM 2021 are stated by them.
        </p>
        <h2 className="h2">
        <MathComponent tex={String.raw`\int_0^1 x^2\ dx`} />
        </h2>
      </div>
    </div>
  );
}
